import { render, staticRenderFns } from "./PrepaymentsFilterAttributes.vue?vue&type=template&id=238a5671&"
import script from "./PrepaymentsFilterAttributes.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PrepaymentsFilterAttributes.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports